import React, { ReactNode } from 'react';
import { Result, ResultVariants } from '@dexma/ui-components';
import i18n from 'asset/translation';
import Bot from 'asset/images/bot.svg';

interface IErrorBoundaryState {
    hasError: boolean;
}

type IErrorBoundaryProps = {
    onError: (props: { stack: string; message: string }) => void;
    children: ReactNode;
};

class ErrorBoundary extends React.Component<IErrorBoundaryProps, IErrorBoundaryState> {
    constructor(props: IErrorBoundaryProps) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(): unknown {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    componentDidCatch(error: Error, errorInfo: { componentStack: string }): void {
        this.props.onError({ message: error.message, stack: errorInfo.componentStack });
    }

    render(): ReactNode {
        const { hasError } = this.state;
        if (hasError) {
            return <Result variant={ResultVariants.DEFAULT} title={i18n.t('common.errorTryAgain')} iconElement={Bot} />;
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
